import { ChatMockApi } from 'app/mock-api/apps/chat/api';
import { MessagesMockApi } from 'app/mock-api/common/messages/api';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { NotificationsMockApi } from 'app/mock-api/common/notifications/api';
import { ShortcutsMockApi } from 'app/mock-api/common/shortcuts/api';
import { UserMockApi } from 'app/mock-api/common/user/api';
import { LeaderboardMockApi } from './apps/leaderboard/api';
import { AchievementsMockApi } from './apps/achievements/api';
import { PlayMenuMockApi } from './apps/play/api';

export const mockApiServices = [
	ChatMockApi,
	MessagesMockApi,
	NavigationMockApi,
	NotificationsMockApi,
	ShortcutsMockApi,
	UserMockApi,
	LeaderboardMockApi,
	AchievementsMockApi,
	PlayMenuMockApi,
];
